/**
 * Control Panel for Codemirror.
 * Display current page and next/prev page buttons.
 * @module controlPanel
 * @category CodeMirror
 */

import { EditorView, type Panel, showPanel } from "@codemirror/view";
// import { strings } from "@quickpoint.me/shared";
import pageCounter from "../../lib/editor/pageCounter";
import { pageNumbersGutterState } from "@quickpoint.me/shared/editor";

// the controls attached with react portal.

/**
 * Move to next page ctrl char in code
 * Pages are base 1
 */
function nextPage(view: EditorView) {
  const currentPage = view.state.field(pageCounter);
  const nextPageIDx = currentPage + 1;

  moveCursorToPageIndex(view, nextPageIDx);
}

/**
 * Move to prev page ctrl char in code
 * Pages are base 1
 */
function prevPage(view: EditorView) {
  const currentPage = view.state.field(pageCounter);
  const prevPageIDx = currentPage - 1;

  moveCursorToPageIndex(view, prevPageIDx);
}

/**
 * Move cursor to a page by index
 */
export const moveCursorToPageIndex = (view: EditorView, pageIdx: number) => {
  const pageNumbersState = view.state.field(pageNumbersGutterState);
  if (Array.isArray(pageNumbersState)) {
    // Pages are base 1
    // BUT pageNumbersState is base 0
    const moveTo = pageNumbersState.find(page => page.pageIdx === pageIdx);
    if (!moveTo) return;

    const scrollEffect = EditorView.scrollIntoView(moveTo.line.from, {
      y: "center",
    });
    view.dispatch({
      effects: [scrollEffect],
      selection: { anchor: moveTo.line.from },
    });
  }
};

/**
 * Move control panel elements
 */
function controlPanel(view: EditorView): Panel {
  const navNode = document.createElement("div");
  const mainPanel = document.createElement("div");

  const nextButton = document.createElement("img");
  const prevButton = document.createElement("img");
  const pageNumber = document.createElement("div");

  mainPanel.className = "cm-navigation-panel";
  navNode.className = "cm-control-panel-nav";

  pageNumber.className = "cm-page-counter";
  nextButton.className = "cm-control-panel-button next";
  prevButton.className = "cm-control-panel-button prev";



  pageNumber.textContent = "page 1";

  navNode.appendChild(prevButton);
  navNode.appendChild(pageNumber);
  navNode.appendChild(nextButton);

  mainPanel.append(navNode);

  nextButton.onclick = () => nextPage(view);
  prevButton.onclick = () => prevPage(view);

  return {
    top: false,
    dom: mainPanel,
    update(update) {
      const currentPage = update.state.field(pageCounter);
      pageNumber.textContent = `page ${currentPage}`;
    },
  };
}

export function navigationPanelExtension() {
  return showPanel.of(controlPanel);
}
